module.exports = __webpack_public_path__ + "static/media/icon-more.4b3e90b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-more.svg
// module id = 178
// module chunks = 0